<template>
  <div>
    <el-dialog
      title="选择采集对象"
      :visible.sync="visible"
      :width="'800px'"
      :style="{ zIndex: 10000 }"
    >
      <div>
        <div class="view-filter">
          <el-form ref="form" :inline="true" :model="form" layout="inline">
            <el-form-item>
              <el-input
                v-model="form.search_text"
                class="search-text"
                size="small"
                style="width: 280px; margin-top: 2%"
                placeholder="请输入档案编码/名称"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div class="box left">
            <div class="header">未选：{{ left.length }}</div>
            <div class="list-body">
              <ul class="list-content">
                <li class="list-item list-header">
                  <span>档案编码</span>
                  <span>档案名称</span>
                </li>
                <li
                  class="list-item"
                  v-for="item in left"
                  :key="item.client_id"
                  @click="leftSelect(item.client_id)"
                >
                  <span>{{ item.client_code }}</span>
                  <span>{{ item.client_name }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="box middle">
            <el-button
              type="primary"
              :style="buttonStyle"
              :size="'small'"
              @click="selectAll"
              :disabled="selectedAll || left.length === 0"
            >
              全选
            </el-button>
            <el-button
              type="primary"
              :style="buttonOneStyle"
              :size="'small'"
              @click="removeAll"
              :disabled="right.length === 0"
            >
              清空
            </el-button>
          </div>
          <div class="box right">
            <div class="header">已选：{{ right.length }}</div>
            <div class="list-body">
              <ul class="list-content">
                <li class="list-item list-header right">
                  <span>档案编码</span>
                  <span>档案名称</span>
                </li>
                <li
                  class="list-item right"
                  v-for="item in right"
                  :key="item.client_id"
                  style="display: flex"
                >
                  <span>{{ item.client_code }}</span>
                  <span>{{ item.client_name }}</span>
                  <i
                    class="el-icon-close"
                    style="cursor: pointer; position: relative; left: 21px; top: 11px;"
                    @click="rightDelete(item)"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <el-pagination
          :key="currentPage"
          background
          @current-change="onChangePage"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount"
          style="margin-top: 10px"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save" :disabled="right.length === 0"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { temporaryGetClientList } from "@/api/index";

export default {
  name: "SelectCollectTargetModal",
  data() {
    return {
      buttonStyle: {
        display: "block",
        marginBottom: "4px",
      },
      buttonOneStyle: {
        display: "block",
        marginBottom: "4px",
        marginLeft: "1px",
        marginTop: "10px",
      },
      visible: false,
      left: [],
      right: [],
      allClientList: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      selectedAll: false,
      form: {
        search_text: "",
      },
      initSelection: [] // 存储初始选中的数据
    };
  },
  methods: {
    async open(initSelection = []) {
      this.visible = true;
      this.initSelection = [...initSelection];
      this.right = [...initSelection];
      await this._getPage(1);
    },
    
    async _getPage(page) {
      try {
        const res = await temporaryGetClientList(
          page,
          this.form.search_text,
          ''
        );
        if (res.status === 0) {
          this.allClientList = res.data.clientPage;
          this.left = [...res.data.clientPage];
          this._filterLeft();
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
        } else {
          this.left = [];
          this.totalCount = 0;
        }
      } catch (error) {
        this.$message.error('获取列表失败');
      }
    },

    onSearch() {
      this._getPage(1);
    },

    leftSelect(id) {
      if (this.right.length >= 20) {
        this.$message.warning('最多只能选择20个采集对象');
        return;
      }
      const target = this.left.find(item => item.client_id === id);
      if (target) {
        this.right.push(target);
        this.left = this.left.filter(item => item.client_id !== id);
      }
    },

    rightDelete(item) {
      this.right = this.right.filter(i => i.client_id !== item.client_id);
      this.left.push(item);
    },

    selectAll() {
      if (this.left.length + this.right.length > 20) {
        this.$message.warning('最多只能选择20个采集对象');
        return;
      }
      this.right = [...this.right, ...this.left];
      this.left = [];
      this.selectedAll = true;
    },

    removeAll() {
      this.left = [...this.left, ...this.right];
      this.right = [];
      this.selectedAll = false;
    },

    _filterLeft() {
      const rightIds = this.right.map(item => item.client_id);
      this.left = this.left.filter(item => !rightIds.includes(item.client_id));
    },

    onChangePage(page) {
      this._getPage(page);
    },

    save() {
      this.$emit('on-success', this.right);
      this.visible = false;
      this.reset();
    },

    cancel() {
      this.visible = false;
      this.reset();
    },

    reset() {
      this.form.search_text = '';
      this.left = [];
      this.right = [];
      this.currentPage = 1;
      this.selectedAll = false;
    }
  }
};
</script>

<style scoped lang="scss">
// 保持原有样式不变
.icon-close {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;

  &:hover {
    color: #000;
  }
}

.box {
  display: inline-block;
  vertical-align: middle;

  &.left,
  &.right {
    position: relative;
    padding-top: 34px;
    width: 330px;
    height: 400px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .header {
      padding: 6px 12px;
      border-radius: 4px 4px 0 0;
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      border-bottom: 1px solid #e8e8e8;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .list-body {
      position: relative;
      height: 100%;
      font-size: 14px;

      .list-content {
        padding: 0;
        padding-top: 42px;
        height: 100%;
        overflow: auto;
        list-style: none;
        margin: 0;
      }
    }
  }

  &.left {
    .list-item {
      cursor: pointer;
    }
  }

  &.middle {
    overflow: hidden;
    margin: 0 8px;
  }
}

.view-filter {
  margin-bottom: 20px;
}

.list-item {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 32px;
  transition: all 0.3s;
  list-style: none;

  &:hover {
    background-color: #e6f7ff;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    padding: 10px;
    width: 49%;
    &:last-of-type {
      width: 50%;
    }
  }

  &.right {
    padding-right: 32px;
  }
}

.list-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  z-index: 2;

  span {
    background: #fafafa;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
}
</style>
  